import { createContext, useState, useEffect, useMemo } from 'react';
import ConvertSDK from '@convertcom/js-sdk';
import configData from '../config.json';
import { isNonProdHost } from '../utils/environment';

const ConvertContext = createContext(null);

export const ConvertProvider = ({ children }) => {
  const [convertContext, setConvertContext] = useState(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Convert project config only exists for production; non-prod requests 404
    if (isNonProdHost()) return;

    const sdk = new ConvertSDK({
      sdkKey: configData['AirswiftDigitalConvertSDK:SdkKey'],
      environment: 'production'
    });

    const handleSdk = async () => {
      await sdk.onReady();
      await setConvertContext(sdk.data.experiences);
      await setIsReady(true);
    };

    handleSdk();
  }, []);

  const contextValue = useMemo(() => ({ convertContext, isReady }), [convertContext, isReady]);

  return <ConvertContext.Provider value={contextValue}>{children}</ConvertContext.Provider>;
};
